import { formatDate } from "@angular/common";

const DEFAULT_LOCALE = "en-SG";
const DEFAULT_DATE_TIME_FORMAT = "dd/MM/yyyy HH:mm:ss";

/**
 * Formats a date/time string into the browser's local time display.
 *
 * Example input/output:
 * - "2026-03-31T01:54:22.906884984Z" -> "31/03/2026 09:54:22" in UTC+08:00
 * - null -> "-"
 * - "not-a-date" -> "not-a-date"
 */
export function formatLocalDateTime(
  value: string | null | undefined,
  options?: {
    fallback?: string;
    format?: string;
    locale?: string;
  },
): string {
  const fallback = options?.fallback ?? "-";

  if (!value) {
    return fallback;
  }

  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) {
    return value;
  }

  return formatDate(
    parsedDate,
    options?.format ?? DEFAULT_DATE_TIME_FORMAT,
    options?.locale ?? DEFAULT_LOCALE,
  );
}
